import { useTaskListQuery } from 'common/cache';
import { useAllWorklistContext } from 'views/pages/Worklist/AllWorklist/contexts/AllWorklistContext.ts';
import { ITaskTableEntry } from 'views/pages/Worklist/common/TaskTable/hooks';
import { TASK_PRIORITY } from 'common/types';

export const useCompleted = () => {
  const {
    completedFilters,
    handleCompletedFilterChange,
    handleOpenTaskDetails,
    selectedTaskId,
    handleFullResetCompletedFilters,
    isFiltersCardOpen,
    handleCloseFiltersCard,
    handleToggleFiltersCard,
  } = useAllWorklistContext();

  const {
    data = {
      count: 0,
      tasks: [],
    },
    isFetching,
    isRefetching,
  } = useTaskListQuery(completedFilters);

  const entries: ITaskTableEntry[] = data.tasks.map(task => ({
    ...task,
    priority: task.priority as TASK_PRIORITY,
  }));

  return {
    isFiltersCardOpen,
    handleCloseFiltersCard,
    handleToggleFiltersCard,
    entries,
    isLoading: isFetching || isRefetching,
    filters: completedFilters,
    handleCompletedFilterChange,
    totalCount: data.count,
    handleOpenTaskDetails,
    selectedTaskId,
    isInitialFilters: false,
    handleFullResetCompletedFilters,
    // isInitialFilters:
    //   JSON.stringify(completedFilters) === JSON.stringify(initialFilters),
  };
};
